import { Component, OnInit } from '@angular/core';
import { LoaderComponent } from '../loader/loader.component';
import { DocViewerComponent } from '@modules/search/components/doc-view/components/doc-viewer/doc-viewer.component';

@Component({
  selector: 'app-file-preview',
  standalone: true,
  imports: [LoaderComponent, DocViewerComponent],
  templateUrl: './file-preview.component.html',
  styleUrl: './file-preview.component.scss'
})
export class FilePreviewComponent implements OnInit {
  isLoading : boolean = true;
  data : any;
  constructor() { }

  ngOnInit(): void {
    let filePreviewData = localStorage.getItem('filePreviewData');
    if(filePreviewData){
      this.isLoading = false;
      this.data = JSON.parse(filePreviewData);
      localStorage.removeItem('filePreviewData');
      document.documentElement.style.setProperty(`--topNav-height`, `-15.5rem`);
    }
  }

}
